import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { IMAGES } from "@/lib/assets";
import { useLanguage } from "@/i18n/LanguageContext";

const names = ["C. R.", "A. B.", "S. M."];

const FADE_UP_40 = { opacity: 0, y: 40 };
const FADE_UP_50 = { opacity: 0, y: 50 };
const FADE_IN = { opacity: 1, y: 0 };
const VP_ONCE = { once: true };
const VP_60 = { once: true, margin: "-60px" };
const T_HEADER = { duration: 0.9 };

export const Testimonials = () => {
  const { t } = useLanguage();
  const items = t("testimonials.items");
  const testimonials = names.map((name, i) => ({
    name,
    quote: items[i].quote,
    role: items[i].role,
  }));
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 sm:py-40 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20">
        <img src={IMAGES.testimonial} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1420]/80" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={FADE_UP_40}
          whileInView={FADE_IN}
          viewport={VP_ONCE}
          transition={T_HEADER}
          className="text-center max-w-2xl mx-auto mb-20"
        >
          <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-6">
            {t("testimonials.eyebrow")}
          </p>
          <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl text-white">
            {t("testimonials.title")} <span className="gold-gradient-text italic">{t("testimonials.titleAccent")}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item, i) => (
            <motion.div
              key={item.name}
              initial={FADE_UP_50}
              whileInView={FADE_IN}
              viewport={VP_60}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              data-testid={`testimonial-${i}`}
              className="bg-[#0B1622]/80 backdrop-blur-sm border border-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all duration-500 p-10 flex flex-col"
            >
              <Quote className="text-[#D4AF37] mb-6" size={34} />
              <p className="font-serif-lux italic text-xl leading-relaxed text-white/90 flex-1">
                "{item.quote}"
              </p>
              <div className="mt-8 pt-6 border-t border-white/10">
                <p className="text-white font-medium tracking-wide">{item.name}</p>
                <p className="text-[#A0ABC0] text-sm mt-1">{item.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
